// extracted by css-extract-rspack-plugin
export default {"confirmationContent":"IssueDeletionConfirmationDialog-module__confirmationContent__GzLuN","confirmationList":"IssueDeletionConfirmationDialog-module__confirmationList__dvEqF"};